import { render, staticRenderFns } from "./ExportConsumeOTBitacora.vue?vue&type=template&id=6273b42c&"
import script from "./ExportConsumeOTBitacora.vue?vue&type=script&lang=js&"
export * from "./ExportConsumeOTBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports